module.exports = __webpack_public_path__ + "img/music.ec55f497.png";